<template>
  <v-row no-gutters>
    <v-col>
      <v-card flat outlined class="my-1" :class="'potentialorder'">
        <v-card flat class="pa-3 hidecaret" color="transparent" :ripple="false" @click.stop="collapsed = !collapsed">
          <v-row no-gutters align="center">
            <v-col cols="2">
              {{ i18nFormatDate(MinPeriod) }} - {{ i18nFormatDate(MaxPeriod) }}
            </v-col>
            <v-col cols="2">
              <v-btn small outlined color="primary" :disabled="!HasLines || IsWorking" @click.stop="generate"
                :loading="IsWorking">
                Generate order
              </v-btn>
            </v-col>
            <v-col cols="4">
              {{ item.CustomerId }} {{ item.CustomerName }}
            </v-col>
            <v-col class="d-flex justify-end pr-3">
              {{ formatCurrencyTotal(TotalAmountExclVat) }}
            </v-col>
            <v-col cols="1" class="d-flex justify-end">
              <v-btn small icon @click.stop="collapsed = !collapsed">
                <v-icon v-text="collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up'"></v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <template v-if="!collapsed">
          <v-divider></v-divider>
          <v-card flat outlined class="pa-3">
            <v-row no-gutters align="center" v-for="detail in Details" :key="detail.Id">
              <v-col cols="2" :class="[pausedClass(detail), hasOrderIdClass(detail)]">
                {{ i18nFormatDate(detail.PaymentPlan.PaymentStartDate) }} - {{
                  i18nFormatDate(detail.PaymentPlan.PaymentEndDate) }}
              </v-col>
              <v-col cols="8" :class="[pausedClass(detail), hasOrderIdClass(detail)]">
                {{ detail.ContractDetail.Qty }}x {{ DetailName(detail) }}
                <v-chip v-if="detail.Overdue" color="warning" class="ml-2" x-small>
                  Overdue
                </v-chip>
              </v-col>
              <v-col class="d-flex justify-end pr-3" :class="[pausedClass(detail)]">
                {{ formatCurrencyTotal(detail.Order.TotalAmountExclVat - detail.Order.TotalDiscount) }}
              </v-col>
              <v-col cols="1" class="d-flex justify-end">
                <v-btn v-if="detail.PaymentPlan.CreateOrder && !hasOrderId(detail)" small icon @click="unlock(detail)"
                  color="warning" :disabled="IsWorking">
                  <v-icon>mdi-lock-reset</v-icon>
                </v-btn>
                <v-btn v-if="!hasOrderId(detail)" :loading="detail.IsWorking" small icon
                  @click="detail.IsPaused = !detail.IsPaused" :color="detail.IsPaused && 'success'">
                  <v-icon>mdi-motion-pause-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
          <v-divider></v-divider>
          <v-row no-gutters style="background-color: rgb(0 0 0 / 1%);" class="px-3 pb-3">
            <v-col>
              <v-row no-gutters class="py-1 mt-1" style="border-bottom: 1px solid rgb(0 0 0 / 20%);">
                <v-col cols="2">
                  Article
                </v-col>
                <v-col cols="0">
                  Text
                </v-col>
                <v-col cols="1" class="d-flex justify-end">
                  Qty
                </v-col>
                <v-col cols="2" class="d-flex justify-end">
                  Unit price
                </v-col>
                <v-col cols="2" class="d-flex justify-end">
                  Line total
                </v-col>
              </v-row>
              <v-row v-for="detail in OrderDetails" :key="detail.Id" no-gutters class="py-1"
                style="border-bottom: 1px solid rgb(0 0 0 / 6%);">
                <v-col cols="2">
                  {{ detail.ArticleNumber }}
                </v-col>
                <v-col cols="0" class="nowrapheader">
                  {{ detail.ArticleDescription }}
                </v-col>
                <v-col cols="1" class="d-flex justify-end">
                  {{ detail.ArticleCount }} x
                </v-col>
                <v-col cols="2" class="d-flex justify-end">
                  {{ formatCurrencyTotal(detail.ArticlePrice) }}
                </v-col>
                <v-col cols="2" class="d-flex justify-end">
                  {{ formatCurrencyTotal(detail.TotalAmountExclVat - (detail.TotalDiscount || 0)) }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="0">
                </v-col>
                <v-col class="d-flex justify-end pt-3" cols="auto">
                  <p class="ma-0 mr-3">Order total:</p>
                  {{ formatCurrencyTotal(TotalAmountExclVat) }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </v-col>
  </v-row>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin";
export default {
  name: 'ContractPaymentPlanPreviewCard',
  props: {
    item: Object,
  },
  components: {},

  data() {
    return {
      collapsed: true,
    };
  },
  methods: {
    unlock(detail) {
      clientAPI.methods.unlockPaymentPlanForOrderGeneration([detail.PaymentPlan.Id]).then(() => {
        detail.PaymentPlan.CreateOrder = false;
      });
    },
    generate() {
      clientAPI.methods.generateContractOrdersFromPaymentPlans(
        this.Details.filter(d => !(d.IsPaused || d.IsLocked)).map(d => d.PaymentPlan.Id)
      );
    },
    DetailName(detail) {
      return detail.ContractDetail.Machine?.DisplayName
        ?? detail.ContractDetail.Article?.ArticleNumber.concat(' - ', detail.ContractDetail.Article.ArticleDescription)
        ?? detail.ContractDetail.ContractArticle.ArticleNumber.concat(' - ', detail.ContractDetail.ContractArticle.ArticleDescription)
    },
    pausedClass(detail) {
      return detail.IsPaused ? 'paused' : '';
    },
    hasOrderIdClass(detail) {
      return detail.OrderId ? 'has-order-id' : '';
    },
    hasOrderId(detail) {
      return detail.OrderId != null;
    },
  },
  computed: {
    IsWorking() {
      return this.Details.some(d => d.IsWorking);
    },
    HasLines() {
      return this.Details.some(d => !(d.IsPaused || d.IsLocked));
    },
    MinPeriod() {
      return this.Details
        .filter(d => !(d.IsPaused || d.IsLocked))
        .reduce((min, d) => d.PaymentPlan.PaymentStartDate < min
          ? d.PaymentPlan.PaymentStartDate
          : min,
          this.Details[0].PaymentPlan.PaymentStartDate);
    },
    MaxPeriod() {
      return this.Details
        .filter(d => !(d.IsPaused || d.IsLocked))
        .reduce((max, d) => d.PaymentPlan.PaymentEndDate > max ? d.PaymentPlan.PaymentEndDate : max,
          this.Details[0].PaymentPlan.PaymentEndDate);
    },
    Details() {
      return this.item.Details;
    },
    OrderDetails() {
      return this.item
        .Details
        .filter(d => !(d.IsPaused || d.IsLocked))
        .map(d => d.Order.OrderDetails)
        .reduce((a, b) => a.concat(b), []);
    },
    TotalAmountExclVat() {
      return this.item.Details
        .filter(d => !(d.IsPaused || d.IsLocked))
        .map(d => d.Order.TotalAmountExclVat - (d.Order.TotalDiscount || 0))
        .reduce((a, b) => a + b, 0);
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
.hidecaret.v-card--link:before {
  background: none;
  background-color: transparent;
}

.potentialorder {
  border: 1px dashed #9e9e9e !important;
  background-color: rgba(255, 255, 255, 0.641);
}

.paused {
  text-decoration: line-through;
}

.has-order-id {
  color: var(--v-success-base);
  opacity: 0.5;
}
</style>